import React from 'react';
import { acpYesOptions } from './utils';

interface YesColumnProps {
  yesValue: string | null;
  setYesValue: React.Dispatch<React.SetStateAction<string | null>>;
  setNoValue: React.Dispatch<React.SetStateAction<string | null>>;
}

const YesColumn: React.FC<YesColumnProps> = ({
  yesValue,
  setYesValue,
  setNoValue,
}) => {
  return (
    <div
      className="govuk-radios care-status__radios mb-5"
      data-module="govuk-radios"
    >
      {acpYesOptions.map(option => {
        return (
          <div className="govuk-radios__item" key={option.value}>
            <input
              className="govuk-radios__input"
              id={option.value}
              name={option.value}
              type="radio"
              value={option.value}
              checked={yesValue === option.value}
              onChange={e => {
                setYesValue(e.target.value);
                setNoValue(null);
              }}
            />
            <label
              className="govuk-label govuk-radios__label"
              htmlFor={option.value}
            >
              {option.label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default YesColumn;
